import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=01325b4b&"
import script from "./SimpleSelect.vue?vue&type=script&lang=js&"
export * from "./SimpleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSelect.vue?vue&type=style&index=0&id=01325b4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports